if (!customElements.get('lc-product-video-carousel')) {
  customElements.define(
    'lc-product-video-carousel',
    class LcProductVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.videos = this.querySelectorAll('.lc-product-video-carousel__video');
        this.addEventListener('click', (e) => this.handleClick(e));
        this.initIntersectionObserver();
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      initIntersectionObserver() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target.querySelector('.lc-product-video-carousel__video');
              if (video) {
                if (entry.isIntersecting) {
                  video.play().catch(() => {});
                } else {
                  video.pause();
                  video.muted = true;
                  const slide = entry.target;
                  slide.classList.remove('lc-product-video-carousel__slide--playing-audio');
                }
              }
            });
          },
          { threshold: 0.3 }
        );

        const slides = this.querySelectorAll('.lc-product-video-carousel__slide');
        slides.forEach((slide) => this.observer.observe(slide));
      }

      handleClick(e) {
        const wrapper = e.target.closest('.lc-product-video-carousel__video-wrapper');
        if (!wrapper) return;

        const video = wrapper.querySelector('.lc-product-video-carousel__video');
        if (!video) return;

        const slide = wrapper.closest('.lc-product-video-carousel__slide');

        if (video.muted) {
          video.muted = false;
          video.play().catch(() => {});
          slide.classList.add('lc-product-video-carousel__slide--playing-audio');

          this.videos.forEach((otherVideo) => {
            if (otherVideo !== video) {
              otherVideo.muted = true;
              otherVideo.pause();
              const otherSlide = otherVideo.closest('.lc-product-video-carousel__slide');
              if (otherSlide) {
                otherSlide.classList.remove('lc-product-video-carousel__slide--playing-audio');
              }
            }
          });
        } else {
          video.muted = true;
          slide.classList.remove('lc-product-video-carousel__slide--playing-audio');
        }
      }
    }
  );
}
